module.exports = __webpack_public_path__ + "static/img/pineapple-m.ec1b021.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backgrounds/pineapple-m.jpg
// module id = DaG7
// module chunks = 0